import { SettingsPageLayout } from "../components/SettingsPageLayout";
import { useNavigate } from "react-router-dom";
import { AssumptionsForm } from "./AssumptionsForm";

/**
 * Assumptions page - Mobile implementation
 * Full-screen form with swipe navigation (< 768px)
 */
function AssumptionsMobile() {
  const navigate = useNavigate();

  return (
    <SettingsPageLayout
      title="Assumptions"
      category="assumptions"
      onBack={() => navigate("/settings")}
    >
      <AssumptionsForm />
    </SettingsPageLayout>
  );
}

export default AssumptionsMobile;
